import axios from 'axios';

export async function NewRevision(timeDimensionId: number, description: string) {
  try {
    axios.post(`/api/versions/${timeDimensionId}`, { description });
  } catch (error) {
    throw new Error('Kunde inte hämta tidsdimensioner');
  }
}
